import { render, staticRenderFns } from "./MoneyComponent.vue?vue&type=template&id=7357d046&scoped=true&"
import script from "./MoneyComponent.vue?vue&type=script&lang=js&"
export * from "./MoneyComponent.vue?vue&type=script&lang=js&"
import style0 from "./MoneyComponent.vue?vue&type=style&index=0&id=7357d046&scoped=true&lang=css&"
import style1 from "./MoneyComponent.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7357d046",
  null
  
)

export default component.exports